const config = require('../config'); const apiConfig = require('../api-config');
const apiFactory = require('../resources/currencies/api-factory');
const serviceFactory = require('../resources/currencies/service-factory');

function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/userprofile/${apiConfig.apiversion}/`,
  });

  const service = serviceFactory({ api });
  const p = '[{keys:metaData}].';

  return app => app
     .match(`${p}currencies.saveCurrency[{keys:currency}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.saveCurrency(req.params.currency, req.params.metaData)
          .then(response => res.value(response.currencySuccess))
          .catch(res.error)
      )))
    .match(`${p}currencies.getCurrency`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.getCurrency(req.params.metaData)
          .then(response => res.value(response.currency))
          .catch(res.error)
      )));
}

module.exports = addRoutes;
